import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class EngineerService {
    constructor(private http: HttpClient, private snotifyService: SnotifyService) {
    }

    public get(id: string = null): Promise<any> {
        return new Promise((resolve, reject) => {
          this.http.get<any>(environment.apiUrl + "engineer/GetById?id=" + id).subscribe(data => {
                resolve(data);
            }, error => {
                //console.log(error);
                reject();
            });
        });
    }
  //this.filter.company_Id, this.filter.location_Id, this.filter.name, this.filter.email
  public getTable(company_Id: number, location_Id: number, name: string, email: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = 'name=' + name;

      this.http.get<any>(environment.apiUrl + "engineer/gettable?" + params).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }
  public getEngineerCounts(): Promise<any> {
    return new Promise((resolve, reject) => {

      this.http.get<any>(environment.apiUrl + "engineer/GetEngineerCounts" ).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }


    public add(user): Promise<any> {
        return new Promise((resolve, reject) => {
            //console.log(user);
            this.http.post<any>(environment.apiUrl + 'engineer/post', user).subscribe(data => {
                resolve(data);
                this.snotifyService.success('Successfully added web user');
            }, error => {
              //console.log(error);
              this.snotifyService.error(error);
                reject();
            });
        });
    }

  public update(user): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + 'engineer/post', user).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully added web user');
      }, error => {
        //console.log(error);
        if (error.error.includes('license count'))
          this.snotifyService.error('You have exceeded your license count');
        else
        this.snotifyService.error(error.error);
        reject();
      });
    });
  }

    public delete(id): Promise<any> {
      return new Promise((resolve, reject) => {
          this.http.delete<any>(environment.apiUrl + 'engineer/delete?id=' + id).subscribe(data => {
              resolve(data);
            this.snotifyService.success('Successfully deleted engineer');
          }, error => {
              //console.log(error);
              reject();
          });
      });
  }

}
